import React from 'react';
import useBreadcrumbs from "use-react-router-breadcrumbs";
import { NavLink } from "react-router-dom";

const routes = [
  { path: '/personas/edit', breadcrumb: 'doNotDisplay' },
  { path: '/personas/edit/:id', breadcrumb: 'Edit' },
  { path: '/new-personas/:id', breadcrumb: 'Edit' },
  { path: '/content/edit/:type/:id', breadcrumb: 'Edit' },
  { path: '/content/edit', breadcrumb: 'doNotDisplay' },
  { path: '/article/edit', breadcrumb: 'doNotDisplay' },
  { path: '/article/edit/:id', breadcrumb: 'Edit' },
  { path: '/playlist/edit', breadcrumb: 'doNotDisplay' },
  { path: '/playlist/edit/:id', breadcrumb: 'Edit' },
  { path: '/content', breadcrumb: 'doNotDisplay' },
];

const Breadcrumbs = () => {
  const breadcrumbs = useBreadcrumbs(routes);

  return (
    <>
      {breadcrumbs.map(({ match, breadcrumb }) => {
        // @ts-ignore
        if (breadcrumb.props.children === 'doNotDisplay') {
          return null;
        }

        return <span key={match.pathname} id={match.pathname}>
          <NavLink to={match.pathname}>{breadcrumb}</NavLink>
        </span>
      })}
    </>
  );
};

export default Breadcrumbs;